/*!
 * Job Description XDS - Version: 1.8.0
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

const clickOutsideExampleModalEventHandler = function(e){
  const showMoreButtons = document.querySelectorAll('.jd-examples-card-show-more-btn');
  if (showMoreButtons) {
    for (const btn of showMoreButtons) {
      if (btn.contains(e.target)) {
        return;
      }
    }
  }
  const exampleModal = document.querySelector('.jd-examples-card-modal-content-wrapper');
  if (exampleModal && !exampleModal.contains(e.target)){
      const closeButton = document.querySelector('.jd-examples-card-modal-close');
      if (closeButton) {
        closeButton.click();
      }
  }
};

function jdCardCarouselXDS() {
  const exampleBar = document.querySelector('#jd-examples-bar-xds');
  if (exampleBar == null) {
    return;
  }
  const cardList = exampleBar.querySelectorAll('#jd-examples-bar-xds .jd-examples-card');
  const numItems = cardList.length;
  const numCardsPerViewOnDesktop = Math.min(3, numItems);
  const numCardsPerViewOnTablet = Math.min(2, numItems);
  const numCardsPerViewOnMobile = Math.min(2, numItems);
  const swiperOptions = {
    init: false,
    slidesPerView: numCardsPerViewOnMobile,
    slidesPerGroup: numCardsPerViewOnMobile,
    direction: numCardsPerViewOnMobile > 1 ? 'vertical' : 'horizontal',
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    slideToClickedSlide: true,
    simulateTouch: false,
    breakpoints: {
      992: {
        direction: 'horizontal',
        slidesPerView: numCardsPerViewOnDesktop,
        slidesPerGroup: numCardsPerViewOnDesktop,
      },
      768: {
        direction: 'horizontal',
        slidesPerView: numCardsPerViewOnTablet,
        slidesPerGroup: numCardsPerViewOnTablet,
      }
    },
    navigation: {
      nextEl: '.jd-examples-change-page-right-btn',
      prevEl: '.jd-examples-change-page-left-btn'
    },
    pagination: {
      el: '.jd-examples-page-count',
      verticalClass: 'swiper-pagination-horizontal',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
      clickable: true
    },
    on: {
      init: function () {
        computeCarouselHeight();
      },
      changeDirection: function () {
        computeCarouselHeight();
      },
    }
  };
  const swiper = new Swiper('.swiper', swiperOptions);
  swiper.init();
  addClickListenerToOpenModal();

  function addClickListenerToOpenModal() {
    const showMoreButtons = exampleBar.querySelectorAll(".jd-examples-card-show-more-btn");
    for (const showMoreButton of showMoreButtons) {

      showMoreButton.addEventListener('click', button => {
        showMoreButton.blur();
        const exampleTitle = button.target.parentElement.parentElement.querySelector('.jd-examples-card-title');
        const exampleContent = button.target.parentElement.parentElement.querySelector('.jd-examples-card-content');
        const modalTitlePlaceHolder = document.querySelector('#jd-examples-card-modal .jd-examples-card-modal-title');
        const modalExamplePlaceHolder = document.querySelector('#jd-examples-card-modal .jd-examples-card-modal-example');
        modalTitlePlaceHolder.innerHTML = exampleTitle.innerHTML;
        modalExamplePlaceHolder.innerHTML = exampleContent.innerHTML;
        document.querySelector('#jd-examples-card-modal').style.display = "block";
        document.querySelector('body').style.overflow = 'hidden';
        window.addEventListener('click', clickOutsideExampleModalEventHandler);
      });
      showMoreButton.addEventListener("keydown", function(event) {
        if (event.code === "Enter" || event.code === "Space") {
          event.preventDefault();
          event.stopPropagation();
          showMoreButton.click();
        }
      });
    }
  }

  function computeCarouselHeight() {
    const baseHeight = 182; 
    const carousel = exampleBar.querySelector('.jd-examples-carousel');
    if (swiper.isHorizontal()) {
      carousel.style.height = baseHeight + 'px';
    } else {
        carousel.style.height = 2 * baseHeight + swiperOptions.spaceBetween + 'px';
    }
  }
}

function createCopyTool(is_enabled, cta_text, cta_position, tooltip_text, tooltip_button_text, tooltip_button_link) {
  if (!is_enabled) {
    return;
  }
  const POSITION_CLASS = {
    Bottom: 'bottom',
    TopRight: 'top-right',
  };
  let positionClass = POSITION_CLASS.Bottom;
  if (cta_position == 'Top Right') {
    positionClass = POSITION_CLASS.TopRight;
  }
  const ulElements = [
    ...document.querySelectorAll('.job-description-upper-content > ul'),
    ...document.querySelectorAll('.job-description-lower-content > ul'),
    ...document.querySelectorAll('.xds-faqs ul'),
    ...document.querySelectorAll('.smb-faqs > ul') 
  ];
  for (const ulElement of ulElements) {
    const wrapper = document.createElement('div');
    wrapper.className = `copy-tool ${positionClass}`;
    ulElement.parentNode.insertBefore(wrapper, ulElement);
    wrapper.appendChild(ulElement);
    const buttonWrapper = document.createElement('div');
    buttonWrapper.className = `copy-tool-button-wrapper ${positionClass}`;
    const copyToolButtonHTML =
        `<button class='copy-tool-button ${positionClass}' aria-label="${cta_text}">
            <div class="copy-tool-icon" aria-hidden="true"></div>
            ${cta_text}
        </button>
        <div class="copy-tool-tooltip ${positionClass}" role="status" aria-live="polite">
          <span class="copy-tool-tooltip-arrow" aria-hidden="true"></span>
          <span>${tooltip_text}</span>
          <a role="button" onclick="blur()" target="_blank" class="copy-tooltip-link-btn btn btn-primary btn-rounded" href="${tooltip_button_link}">${tooltip_button_text}</a>
        </div>`;
    buttonWrapper.innerHTML = copyToolButtonHTML;
    ulElement.insertAdjacentElement('beforebegin', buttonWrapper);

    const copyToolButton = wrapper.querySelector('.copy-tool-button');
    copyToolButton.addEventListener('click', (event) => {
      let copiedText = '';
      for (const li of ulElement.querySelectorAll('li')) {
        copiedText += `• ${li.textContent}\n`;
      }
      navigator.clipboard.writeText(copiedText);
      const copyToolTooltip = wrapper.querySelector('.copy-tool-tooltip');
      closeAllCopyToolTooltips(event);
      setTimeout(() => {
        copyToolTooltip.style.opacity = 1;
        copyToolTooltip.classList.add('tooltip-activate');
        copyToolButton.blur();
        const copyToolClickEvent = new CustomEvent("copyToolClickEvent", { detail: copiedText});
        window.dispatchEvent(copyToolClickEvent);
        document.addEventListener("click", closeAllCopyToolTooltips);
      }, 0);
    });
  }
}

function closeAllCopyToolTooltips(event) {
  const copyToolTooltips = document.querySelectorAll('.copy-tool-tooltip');
  for (const copyToolTooltip of copyToolTooltips) {
    if (copyToolTooltip.contains(event.target)) {
      return;
    } else if (copyToolTooltip.style.opacity != 0) {
      copyToolTooltip.style.opacity = 0;
      copyToolTooltip.classList.remove('tooltip-activate');
      document.removeEventListener("click", closeAllCopyToolTooltips);
      return;
    }
  }
}

function initializationOnLoad() {
  jdCardCarouselXDS();
  if (window.copy_tool_enabled) {
    createCopyTool(copy_tool_enabled, copy_tool_cta_text, copy_tool_cta_position, copy_tool_tooltip_text, copy_tool_tooltip_button_text, copy_tool_tooltip_button_link);
  }
}

function setupJDModal() {
  const modalCloseButton = document.querySelector('.jd-examples-card-modal-close');
  function closeJDModal() {
    const modalTitlePlaceHolder = document.querySelector('#jd-examples-card-modal .jd-examples-card-modal-title');
    const modalJobExampleHolder = document.querySelector('#jd-examples-card-modal .jd-examples-card-modal-example');
    const modalContentWrapper = document.querySelector('#jd-examples-card-modal .jd-examples-card-modal-content-wrapper');
    modalTitlePlaceHolder.innerHTML = "";
    modalJobExampleHolder.innerHTML = "";
    modalContentWrapper.scrollTo ({top:0});
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('#jd-examples-card-modal').style.display = 'none';
    window.removeEventListener('click', clickOutsideExampleModalEventHandler);
  }

  if (modalCloseButton) {
    modalCloseButton.addEventListener('click', () => {
      closeJDModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.code === "Escape" || e.code === "Enter" || e.code === "Space") {
        if (document.querySelector('#jd-examples-card-modal').style.display === 'block') {
          e.preventDefault();
          e.stopPropagation();
          closeJDModal();
        }
      } else if (e.code === 'Tab') {
        if (document.querySelector('#jd-examples-card-modal').style.display === 'block') {
          if (document.activeElement == modalCloseButton) {
            modalCloseButton.blur();
          } else {
            modalCloseButton.focus();
          }
          e.preventDefault();
        }
      }
    });
  }
}
function putOriginalSalaryExpectationsBack() {
  const urlParams = new URLSearchParams(window.location.search);
  const noSalaryExpectationsJS = urlParams.get('no-salary-expectations-js');
  if (noSalaryExpectationsJS != null && noSalaryExpectationsJS.trim().toLowerCase() === "true") {
    console.log('[salary-expectations] Returning early to show the new salary expectations section even if it has blanks.');
    return;
  }

  const origSalaryExpectationsSection = document.querySelector('.salary-expectations-original');
  const newSalaryExpectationsSection = document.querySelector('.salary-expectations-new');
  if (!newSalaryExpectationsSection) {
    return;
  }
  const hiDataInNewSE = newSalaryExpectationsSection.getElementsByTagName('x-indeed-hi-public');
  let foundEmpty = false;
  for (const hiData of hiDataInNewSE) {
    if (hiData.innerHTML.trim().length === 0) {
      foundEmpty = true;
    }
  }

  if (foundEmpty) {
    console.warn('[salary-expectations] Found an empty hiring insights lookup in salary expectations, using old section.');
    newSalaryExpectationsSection.classList.add('d-none');
    origSalaryExpectationsSection.classList.remove('d-none');
  }
}

window.addEventListener('DOMContentLoaded', initializationOnLoad, { once: true });
window.addEventListener('DOMContentLoaded', setupJDModal, { once: true });
window.addEventListener('DOMContentLoaded', putOriginalSalaryExpectationsBack, { once: true });
let METRIC_EMIT_DELAY_IN_MS = 2000; 
let MAX_RETRY_ATTEMPTS = 5;
let _retry = (fn, retryAttempts = MAX_RETRY_ATTEMPTS, delay = METRIC_EMIT_DELAY_IN_MS) => {
    return async function(...args) {
        for (let i = 0; i <= retryAttempts; i++) {
            let exponentialDelay = delay * Math.pow(2, i); 
            try {
                let result = fn.call(this, ...args);
                if (result) return result; 
                await new Promise(r => setTimeout(r, exponentialDelay));
            } catch (e) {
                await new Promise(r => setTimeout(r, exponentialDelay));
            }
        }
    };
};

const LinkingWidgetConstants = {
    TSV_DATA_SCHEMA_VERSION: 1,
    TSV_DATA_BASE_URL_DEV: "https://d3idcws7fdm94h.cloudfront.net/content-transfer/linking-widget",
    TSV_DATA_BASE_URL_QA: "https://d3v75sr4bu5gc4.cloudfront.net/content-transfer/linking-widget",
    TSV_DATA_BASE_URL_PROD: "https://d341ezm4iqaae0.cloudfront.net/content-transfer/linking-widget",
    TEMPLATE_TO_DISPLAYED_TEXT_MAPPING: {},
    RELATED_CONTENT_SLUG_TRANSLATION: {
        "de": {
            "interviewfragen": "interview-questions",
            "stellenbeschreibung": "job-description",
            "recruitingtipps": "how-to-hire"
        },
        "es": {
            "descripción-del-empleo": "job-description",
            "preguntas-entrevista": "interview-questions",
            "como-contratar": "how-to-hire"
        },
        "fr": {
            "questions-entretien-dembauche": "interview-questions",
            "description-du-poste": "job-description",
            "comment-recruter": "how-to-hire"
        },
        "fr_CA": {
            "questions-entrevue": "interview-questions",
            "comment-embaucher": "how-to-hire"
        },
        "it": {
            "descrizione-dell'-offerta": "job-description",
            "colloquio-domande": "interview-questions",
            "come-assumere": "how-to-hire"
        },
        "ja": {
            "求人票の書き方": "job-description"
        },
        "nl": {
            "sollicitatievragen": "interview-questions",
            "functiebeschrijving": "job-description",
            "recruitment-tips": "how-to-hire"
        },
        "pt": {
            "descrição-da-vaga": "job-description"
        },
        "sv": {
            "jobbeskrivning": "job-description"
        }
    },
    RELATED_CONTENT_DISPLAY_THRESHOLD_MIN: 2,
    RELATED_TITLES_DISPLAY_THRESHOLD_MIN: 2,
    RELATED_TITLES_DISPLAY_THRESHOLD_MAX: 5,
    RELATED_CONTENT: "related_content",
    RELATED_SLUGS: "related_slugs",
    RELATED_CONTENT_ISID: "related_scaled",
    RELATED_SLUGS_ISID: "related_titles",
    LINKING_WIDGET_STATE_UNINITIALIZED: "linking-widget-uninitialized",
    LINKING_WIDGET_STATE_ERROR: "linking-widget-error",
    LINKING_WIDGET_STATE_EMPTY: "linking-widget-empty",
    LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY: "linking-widget-content-column-only",
    LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY: "linking-widget-title-column-only",
    LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS: "linking-widget-two-columns"
};

class LinkingWidget {
    isSet(variable) {
        return !(typeof variable === 'undefined' || variable === null);
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    getGnavConfig() {
        const gnavConfigElement = document.getElementById("_indeed_gnav_config");

        if (gnavConfigElement !== null) {
            const gnavConfig = JSON.parse(gnavConfigElement.textContent);
            return gnavConfig;
        }

        return null;
    }

     getLocale() {
        const gnavConfig = this.getGnavConfig();

        if (gnavConfig !== null && gnavConfig.hasOwnProperty("language")) {
            const hl = gnavConfig.language;
            const co = gnavConfig.country || "US";
            return `${hl}_${co}`;
        }
        const pageWrapElement = document.getElementById("pageWrap");
        if (pageWrapElement && pageWrapElement.className.trim() !== "") {
            const locale = pageWrapElement.className.split(" ")[0]; 
            const twoOrFourLetterLocaleRegex = /^(([a-zA-Z]{2}_[a-zA-Z]{2})|[a-zA-Z]{2})$/;

            if (twoOrFourLetterLocaleRegex.test(locale)) {
                const hl = locale.split("_")[0];
                const co = locale.split("_")[1] || "US";

                return `${hl}_${co}`;
            }
        }

        return "en_US";
     }

    getTranslatedContentTypes(contentType) {
        const locale = this.getLocale();
        const language = locale.split("_")[0];
        if (locale in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale]) {
            return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale][contentType];
        }
        else if (language in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language]) {
            return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language][contentType];
        } else {
            return contentType;
        }
    }
    getDisplayedTextForSlug(slug) {
        for (const data of this.linkingWidgetData) {
            if (data["slug"] === slug) {
                return data["title"];
            }
        }
        throw new Error("Unable to find displayed text for slug.");
    }
    getTitleForRelatedContentColumn(displayedTitle) {
         return displayedTitle;
    }
    getTitleForRelatedTitlesColumn() {
         if(LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"]) {
             return LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"];
         } else {
             throw new Error("Unable to find displayed text for related titles.");
         }
    }

    getCDNBaseUrl() {
        const hostname = window.location.hostname;
        if (hostname.includes(".wpengine.test")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_DEV;
        } else if (hostname.includes(".wpengine.com")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
        } else if (hostname.includes(".qa.indeed.net")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
        } else {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_PROD;
        }
    }
    getIkw() {
        if (this.isSet(subnavSearchSourceId)) {
            return subnavSearchSourceId.replace("subnav_search_", "");
        }
    }

    shouldInitializeLinkingWidget() {
        if (typeof TEMPLATE_TO_DISPLAYED_TEXT_MAPPING === 'undefined') {
            return false;
        }
        LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING = TEMPLATE_TO_DISPLAYED_TEXT_MAPPING;
        return true;
    }

    constructUrl(template, slug, isid, ikw) {
        const hire = window.location.pathname.split("/")[1];
        const query = new URLSearchParams();
        const cookieCO = this.getCookie("CO");
        if (this.isSet(cookieCO)) {
            query.append("co", cookieCO);
        }
        if (this.isSet(isid)) {
            query.append("isid", isid);
        }
        if (this.isSet(ikw)) {
            query.append("ikw", ikw);
        }
        if (this.isSet(query.toString())) {
            return `/${hire}/${template}/${slug}?${query.toString()}`;
        } else {
            return `/${hire}/${template}/${slug}`;
        }
    }

    fetchFile(url) {
        return fetch(url)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.text();
                    return data;
                } else {
                    console.error("Unable to fetch linking widget data");
                }
            })
            .then(data => data)
            .catch(error => error);
    }

    initializeLinkingWidget(linkingWidgetData) {
        if (!this.isSet(linkingWidgetData)) {
            console.error("linkingWidgetData is not found");
            return;
        }
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const slug = urlSegments[urlSegments.length - 1];
        const currentContentType = urlSegments[urlSegments.length - 2];
        let shouldDisplayWidget = false;
        let relatedContent = [];
        let relatedTitles = [];
        let currentLinkingData;
        for (const data of linkingWidgetData) {
            if (data["slug"] === slug) {
                currentLinkingData = data;
                relatedContent = data[LinkingWidgetConstants.RELATED_CONTENT];
                relatedTitles = this.filterValidRelatedSlugsForCurrentContentType(data[LinkingWidgetConstants.RELATED_SLUGS], currentContentType);
                break;
            }
        }
        if (relatedContent.length >= LinkingWidgetConstants.RELATED_CONTENT_DISPLAY_THRESHOLD_MIN) {
            this.insertTitleForRelatedContentColumn(currentLinkingData);
            this.insertRelatedContent(currentLinkingData);
            const node = document.querySelector("#linking-widget-related-content");
            node.style.display = "flex";
            shouldDisplayWidget = true;
        }
        if (relatedTitles.length >= LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MIN) {
            this.insertTitleForRelatedTitlesColumn(currentLinkingData);
            this.insertRelatedTitles(relatedTitles);
            const node = document.querySelector("#linking-widget-related-titles");
            node.style.display = "flex";
            shouldDisplayWidget = true;
        }
        if (shouldDisplayWidget) {
            const linkingWidgetNode = document.querySelector("#linking-widget");
            linkingWidgetNode.style.display = "flex";
        }
    }

    insertTitleForRelatedContentColumn(slugData) {
        const node = document.querySelector("#linking-widget-related-content .linking-widget-title");
        node.insertAdjacentHTML("afterbegin", `<h3> ${this.getTitleForRelatedContentColumn(slugData["title"])}</h3>`);
    }

    insertTitleForRelatedTitlesColumn() {
        const node = document.querySelector("#linking-widget-related-titles .linking-widget-title");
        node.insertAdjacentHTML("afterbegin", `<h3> ${this.getTitleForRelatedTitlesColumn()}</h3>`);
    }

    insertRelatedContent(slugData) {
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const currentContentType = urlSegments[urlSegments.length - 2];
        for (const contentType of slugData[LinkingWidgetConstants.RELATED_CONTENT]) {
            const node = document.querySelector("#linking-widget-related-content .linking-widget-links");
            const hrefUrl = this.constructUrl(contentType, slugData["slug"], LinkingWidgetConstants.RELATED_CONTENT_ISID, this.getIkw());
            const displayedText = LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING[this.getTranslatedContentTypes(contentType)];
            if (!displayedText) {
                continue;
            }
            if (currentContentType === contentType) {
                node.insertAdjacentHTML("beforeend", `<li>${displayedText}</li>`);
            } else {
                node.insertAdjacentHTML("beforeend", `<li><a href="${hrefUrl}" data-tn-component="${LinkingWidgetConstants.RELATED_CONTENT_ISID}" data-tn-link="${this.getIkw()}" data-tn-element="linking-widget-link">${displayedText}</a></li>`);
            }
        }
    }

    insertRelatedTitles(relatedTitles) {
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const currentContentType = urlSegments[urlSegments.length - 2];
        for (const relatedTitle of relatedTitles) {
            const node = document.querySelector("#linking-widget-related-titles .linking-widget-links");
            const hrefUrl = this.constructUrl(currentContentType, relatedTitle, LinkingWidgetConstants.RELATED_SLUGS_ISID, this.getIkw());
            const displayedText = this.getDisplayedTextForSlug(relatedTitle);
            node.insertAdjacentHTML("beforeend", `<li><a href="${hrefUrl}" data-tn-component="${LinkingWidgetConstants.RELATED_SLUGS_ISID}" data-tn-link="${this.getIkw()}" data-tn-element="linking-widget-link">${displayedText}</a></li>`);
        }
    }
    filterValidRelatedSlugsForCurrentContentType(relatedSlugs, currentContentType) {
        const allSlugsForCurrentContentType = [];
        for (const linkingWidgetObject of this.linkingWidgetData) {
            const slug = linkingWidgetObject["slug"];
            const contentTypeArray = linkingWidgetObject[LinkingWidgetConstants.RELATED_CONTENT];
            if (contentTypeArray.includes(currentContentType)) {
                allSlugsForCurrentContentType.push(slug);
            }
        }

        const filteredRelatedSlugs = [];
        for (const relateSlug of relatedSlugs) {
            if (allSlugsForCurrentContentType.includes(relateSlug)) {
                filteredRelatedSlugs.push(relateSlug);
            }
        }

        return filteredRelatedSlugs.sort().slice(0, LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MAX);
    }
    parseTSVToObject(tsvString) {
        const lines = tsvString.split(/\r\n|\r|\n/).filter(element => element);
        const result = [];
        const headers = lines.shift().split("\t");
        for (const line of lines) {
            const obj = {};
            const columns = line.split("\t");
            let validLine = true;
            for (let i = 0; i < headers.length; i++) {
                const header = headers[i];
                if (header === "slug" || header === "title") {
                    if (columns[i] === "") {
                        validLine = false;
                        continue;
                    }
                }
                if (header === "related_content" || header === "related_slugs") {
                    obj[header] = columns[i].replace(/\s/g, "").split(",").filter(element => element);
                } else {
                    obj[header] = columns[i];
                }
            }
            if (validLine) {
                result.push(obj);
            }
        }
        return result;
    }

    setLinkingWidgetTurnstileState(state) {
        const e = document.querySelector("#linking-widget");
        e.setAttribute("data-tn-element", state);
    }

    reportLinkingWidgetTurnstileState() {
        _retry(() => {
                if (!window.commonMetricsLibrary || !window.signals_transport) {
                    return false;
                }
                const e = document.querySelector("#linking-widget")?.getAttribute("data-tn-element");
                window.commonMetricsLibrary.report({"data-tn-element": e, "data-tn-action": "impression"});
                return true;
            }
        )();
    }

    constructor() {
        if (!document.querySelector("#linking-widget")) {
            console.error("Linking widget element does not exist");
            _retry(() => {
                if (!window.commonMetricsLibrary || !window.signals_transport) {
                    return false;
                }
                window.commonMetricsLibrary.report({
                    "data-tn-element": LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED,
                    "data-tn-action": "impression"
                });
                return true;
            })();
            return;
        }

        try {
            let hasError = false;
            this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED);
            if (!this.shouldInitializeLinkingWidget()) {
                this.reportLinkingWidgetTurnstileState();
                return;
            }
            this.fetchFile(`${this.getCDNBaseUrl()}/${LinkingWidgetConstants.TSV_DATA_SCHEMA_VERSION}/${this.getLocale()}.tsv`)
                .then(tsvString => {
                    if (this.isSet(tsvString)) {
                        this.linkingWidgetData = this.parseTSVToObject(tsvString);
                        this.initializeLinkingWidget(this.linkingWidgetData);
                    }
                })
                .catch(error => {
                    this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
                    hasError = true;
                    console.error("Unable to initialize linking widget.", error);
                })
                .finally(() => {
                    if (hasError) {
                        this.reportLinkingWidgetTurnstileState();
                        return;
                    }
                    const contentColumnCount = document.querySelectorAll("#linking-widget-related-content h3").length;
                    const titleColumnCount = document.querySelectorAll("#linking-widget-related-titles h3").length;
                    if (contentColumnCount == 0 && titleColumnCount == 0) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_EMPTY);
                    } else if (contentColumnCount == 1 && titleColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS);
                    } else if (contentColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY);
                    } else if (titleColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY);
                    }
                    this.reportLinkingWidgetTurnstileState();
                });
        } catch(error) {
            console.error("Unable to initialize linking widget.", error);
            this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
            this.reportLinkingWidgetTurnstileState();
        }
    }
}

let linkingWidget;
window.addEventListener('DOMContentLoaded', () => linkingWidget = new LinkingWidget(), {once: true});
const EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY = 'exit-modal-do-not-show';
const EXIT_MODAL_SHOW_ONCE_COOKIE_KEY = 'EXIT_MODAL_ALREADY_SHOWN';
const EXIT_MODAL_SHOW_ONCE_COOKIE_TTL = 300000; 
const MOBILE_INACTIVITY_POLLING_MS = 1000; 
const DESKTOP_DELAY_MS = 1000; 
function setExitModalShownCookie() {
    const now = new Date();
    const currentTime = now.getTime();
    now.setTime(currentTime + EXIT_MODAL_SHOW_ONCE_COOKIE_TTL);
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=true;expires=${now.toUTCString()};path=/`;
}

function deleteExitModalShownCookie() {
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=false;expires=${new Date(0).toUTCString()};path=/`;
}

function checkIfExitModalShownCookieExists() {
    return document.cookie.split(';')
        .some((cookie) => cookie.trim().startsWith(`${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=`));
}
function calculateExitModalStatusForContentTemplates() {
    if (typeof exitModalQueryParameters !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.keys(Object.fromEntries(urlSearchParams.entries()));
        const hasMatchingQueryParam = params.some(param => exitModalQueryParameters.has(param.toLowerCase()));

        if (hasMatchingQueryParam) {
            return true;
        }
    }

    return false;
}

function setupExitModal() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    document.body.insertBefore(exitModalWrapper, document.body.firstChild);

    setupExitModalFocusTrap();

    document.querySelector('.exit-modal-close').addEventListener('click', () => {
        deleteExitModalShownCookie();
        sessionStorage?.setItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY, 'true');
        document.querySelector('.exit-modal-wrapper').classList.add('hide-me');
    });
}

function displayExitModal() {
    setExitModalShownCookie();

    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    exitModalWrapper.classList.remove('hide-me');
    exitModalWrapper.focus();
    try {
        if (window.commonMetricsLibrary) {
            window.commonMetricsLibrary.report({ 'data-tn-element': 'smb-exit-modal', 'data-tn-action': 'impression' });
        }
    } catch (error) {
        console.error('Failed to fire event for exit modal view: ', error);
    }
}
function setupExitModalFocusTrap() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    const focusableElements = exitModalWrapper.querySelectorAll("a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])");
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    exitModalWrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) { 
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    if (!exitModalWrapper) {
        return;
    }

    if (isContentTemplate) {
        const shouldEnableExitModalForContentTemplates = calculateExitModalStatusForContentTemplates();

        if (!shouldEnableExitModalForContentTemplates) {
            console.debug('Disabling exit modal for Content template.');
            document.querySelector('.exit-modal-wrapper').remove();
            return;
        }
        console.debug('Leaving exit modal enabled for Content template based on existence of a query parameter.');
    }

    setupExitModal();
    if (
        ('userAgentData' in navigator && navigator.userAgentData.mobile) 
        || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) 
        || ('msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0) 
        || matchMedia?.('(pointer:coarse)') && matchMedia?.('(pointer:coarse)')?.media === '(pointer:coarse)' 
        || 'orientation' in window 
        || (/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent)) 
    ) {
        let idleTimer = 0;
        ['touchstart', 'touchmove', 'click'].forEach((eventType) => document.addEventListener(eventType, () => idleTimer = 0));

        setInterval(() => {
            idleTimer++;

            if (idleTimer >= 10 
                && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                && exitModalWrapper.classList.contains('hide-me')
            ) {
                displayExitModal();
            }
        }, MOBILE_INACTIVITY_POLLING_MS);
    } else {
        document.addEventListener('mouseout', (event) => {
            if (!event.toElement && !event.relatedTarget) {
                setTimeout(() => {
                    if (!checkIfExitModalShownCookieExists() 
                        && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                        && exitModalWrapper.classList.contains('hide-me')
                    ) {
                        displayExitModal();
                    }
                }, DESKTOP_DELAY_MS);
            }
        });
    }
});

let initialColumnWidth;
function setRightRailStickyBehavior() {
    if (!document.querySelector('.right-rail')) {
        return;
    }
    const sidebarColumn = document.querySelector('.right-rail-full-column, .col-lg-4');
    if (!sidebarColumn) {
        return;
    }
    initialColumnWidth = Math.round(sidebarColumn.clientWidth);
    const bannerResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => adjustRightRailParentHeight(entry.target));
    });
    const sidebarColumnsWithRightRail = Array.from(
        document.querySelectorAll('.right-rail-desktop'), 
        (rightRail) => rightRail.parentElement 
    );
    sidebarColumnsWithRightRail.forEach((column) => {
        bannerResizeObserver.observe(column); 
        column.classList.add('right-rail-full-column'); 
    });
    const contentSectionsWithRightRail = Array.from(document.querySelectorAll('.middle-rail-full-column, .col-lg-8'))
        .filter((contentSection) => contentSection.nextElementSibling !== null && contentSection.nextElementSibling.classList.contains('right-rail-full-column'));
    sidebarColumnsWithRightRail.forEach((column) => {
        window.addEventListener('scroll', () => {
            adjustRightRailParentHeight(column);
            const currentContentSection = [].find.call(contentSectionsWithRightRail, (contentSection) => isScrolledIntoView(contentSection)) || contentSectionsWithRightRail[contentSectionsWithRightRail.length - 1];
            if (currentContentSection) {
                const rightRailForCurrentSection = currentContentSection.nextElementSibling;
                if (rightRailForCurrentSection.style.display === 'none') rightRailForCurrentSection.style.display = '';
                contentSectionsWithRightRail.forEach((contentSection) => {
                    if (contentSection.nextElementSibling.isEqualNode(rightRailForCurrentSection) || contentSection.nextElementSibling.style.display === 'none') return;
                    contentSection.nextElementSibling.style.display = 'none';
                });
            }
        });
    });
}
function adjustRightRailParentHeight(sidebarColumn) {
    if (!sidebarColumn) {
        return;
    }
    if (sidebarColumn.textContent.trim().length <= 0) {
        return;
    }
    if (sidebarColumn.classList.contains('col-lg-3')) {
        return;
    }

    const columnWidth = Math.round(sidebarColumn.clientWidth);
    if (columnWidth <= 0) {
        return;
    }
    if (columnWidth <= initialColumnWidth && window.innerWidth <= 991) {
        sidebarColumn.classList.add('remove-dynamic-min-height-mobile');
        sidebarColumn.style.removeProperty('min-height');
    } else {
        sidebarColumn.classList.remove('remove-dynamic-min-height-mobile');
        const mainColumn = sidebarColumn.closest('.flex-row, .row').querySelector('.col-lg-8');
        if (mainColumn != null) {
            sidebarColumn.style.minHeight = mainColumn.clientHeight + 'px';
        }
    }
    initialColumnWidth = columnWidth;
}
function isScrolledIntoView(element) {
    if (!element) {
        return false;
    }
    const boundingClientRectangle = element.getBoundingClientRect();
    const subnavMenu = document.querySelector('.subnav-menu');
    const offset = subnavMenu
        ? subnavMenu.clientHeight
        : 0;
    const isVisible = boundingClientRectangle.bottom - offset >= 0;

    return isVisible;
}

function randomizeRightRailBannerVariant() {
    if (typeof RIGHT_RAIL_VARIANTS === 'undefined' || !RIGHT_RAIL_VARIANTS || RIGHT_RAIL_VARIANTS.length <= 1) {
        return;
    }

    const randomVariant = RIGHT_RAIL_VARIANTS[Math.floor(Math.random() * RIGHT_RAIL_VARIANTS.length)];
    const rightRailBanners = document.querySelectorAll('.right-rail-banner');
    rightRailBanners.forEach((rightRailBanner) => {
        const rightRailTitle = rightRailBanner.querySelector('.right-rail-title');
        if (rightRailTitle) {
            rightRailTitle.textContent = randomVariant['right_rail_title'];
        }

        const rightRailText = rightRailBanner.querySelector('.right-rail-text');
        if (rightRailText) {
            rightRailText.textContent = randomVariant['right_rail_copy'];
        }

        const rightRailCitation = rightRailBanner.querySelector('.right-rail-citation');
        if (rightRailCitation) {
            rightRailCitation.textContent = randomVariant['right_rail_citation'];
        }

        const rightRailCta = rightRailBanner.querySelector('.right-rail-btn');
        if (rightRailCta) {
            rightRailCta.textContent = randomVariant['right_rail_cta_text'];
            rightRailCta.href = randomVariant['right_rail_cta_link'];
        }

        rightRailBanner.style = randomVariant['right_rail_background_inline_style'];

        currentVariantId = `${TEMPLATE_SLUG}--${randomVariant["right_rail_variant_id"]}`;
    });
}

window.addEventListener('DOMContentLoaded', () => {
    randomizeRightRailBannerVariant();
});

const minimumNumberOfHeadings = 4;
function expandTableOfContents(navLinks, tablesOfContents) {
    navLinks.forEach(function (navLink) {
        navLink.style.height = `${navLinks.scrollHeight}px`;
        navLink.style.maxHeight = 'fit-content'; 
        navLink.classList.add('expand-toc');
    });

    tablesOfContents.forEach(function (tableOfContents) {
        tableOfContents.classList.add('expand-toc');
        const toggleButton = tableOfContents.querySelector('.toggle-toc-button');
        if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'true');
        }
    });

    makeTableOfContentsScrollableIfNeeded();
}

let needsScroll = false;
function makeTableOfContentsScrollableIfNeeded() {
    const desktopTableOfContents = document.querySelectorAll('.table-of-contents.toc-desktop');
    const desktopNavLinks = document.querySelectorAll('.table-of-contents.toc-desktop .nav-links-wrapper');
    const paddingOffset = 200;
    const fullNavHeight = desktopNavLinks[0].querySelector('li').offsetHeight * desktopNavLinks[0].querySelector('.nav-links').childElementCount + paddingOffset;
    if (window.innerWidth >= 992 && (needsScroll || desktopTableOfContents[0].clientHeight > window.innerHeight || fullNavHeight > window.innerHeight)) {
        desktopTableOfContents.forEach((toc) => {
            toc.style.top = '5rem'; 
            toc.querySelector('.toggle-toc-button').style.paddingBottom = '0.5rem';
        });
        desktopNavLinks.forEach((navLink) => {
            navLink.style.maxHeight = `${window.innerHeight - 150}px`; 
            navLink.style.overflowY = 'scroll';
        });
        needsScroll = true; 
    } else {
        desktopTableOfContents.forEach((toc) => {
            toc.style.removeProperty('top');
            toc.querySelector('.toggle-toc-button').style.removeProperty('padding-bottom');
        });
    }
}
function collapseTableOfContents(navLinks, tablesOfContents) {
    navLinks.forEach(function (navLink) {
        navLink.style.maxHeight = '0px'; 
        navLink.classList.remove('expand-toc');
    });

    tablesOfContents.forEach(function (tableOfContent) {
        tableOfContent.classList.remove('expand-toc');
        tableOfContent.style.removeProperty('top');
        const toggleButton = tableOfContent.querySelector('.toggle-toc-button');
        if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'false');
            toggleButton.style.removeProperty('padding-bottom');
        }
    });
}
function toggleTableOfContents() {
    const navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
    const tableOfContents = document.querySelectorAll('.table-of-contents');
    if (navLinks[0].style.maxHeight && navLinks[0].style.maxHeight !== '0px') {
        collapseTableOfContents(navLinks, tableOfContents);
    } else {
        expandTableOfContents(navLinks, tableOfContents);
    }
}
function getArticleHeadings() {
    const articleContentH2HeadingsSelector = 'main .middle-rail-full-column h2, .alphaposts-heading h2';
    const articleContentH2AndH3HeadingsSelector = 'main .middle-rail-full-column h2, .alphaposts-heading h2, main .middle-rail-full-column :not(.linking-widget-title) > h3';
    const nonEmptyH2Headings = Array.from(document.querySelectorAll(articleContentH2HeadingsSelector))
        .filter((element) => (element.innerText !== '' && element.innerHTML !== '&nbsp;'))
        .filter((element) => !element.classList.contains('no-toc'));
    const nonEmptyH2AndH3Headings = Array.from(document.querySelectorAll(articleContentH2AndH3HeadingsSelector))
        .filter((element) => (element.innerText !== '' && element.innerHTML !== '&nbsp;'))
        .filter((element) => !element.classList.contains('no-toc'));
    let nonEmptyHeadings = nonEmptyH2Headings;
    if (nonEmptyHeadings.length < minimumNumberOfHeadings) {
        nonEmptyHeadings = nonEmptyH2AndH3Headings;
    }
    return nonEmptyHeadings;
}
function addHeadingsToTableOfContents(nonEmptyHeadings) {
    const tableOfContentNavLinks = document.querySelectorAll('.table-of-contents .nav-links');
    nonEmptyHeadings.forEach((heading, index) => {
        const headingLevel = 'main-heading';
        const contentHTML = `<li class="${headingLevel}"><a href="#toc-jumpto-${index}">${heading.innerText}</a></li>`;
        heading.setAttribute('id', 'toc-jumpto-' + index);

        tableOfContentNavLinks.forEach(function (toc) {
            toc.insertAdjacentHTML('beforeend', contentHTML);
        });
    });
}

function setupTableOfContentsFocusBehavior() {
    let currentFocusElement = null;
    document.addEventListener('focus', function(event) {
        previousFocusElement = currentFocusElement;
        currentFocusElement = event.target;
    }, true);
}
function setupToggleClickHandlers() {
    document.querySelectorAll('.toggle-toc-button').forEach((toggle) => {
        if (toggle) {
            toggle.addEventListener('click', () => toggleTableOfContents());
        }
    });

    const navLinkWrappers = document.querySelectorAll('.nav-links-wrapper');
    document.querySelectorAll('.table-of-contents .see-more-button').forEach((seeMoreButton) => {
        seeMoreButton.addEventListener('click', () => {
            navLinkWrappers.forEach((navLinkWrapper) => {
                navLinkWrapper.classList.add('show-more-links');
                navLinkWrapper.classList.remove('show-less-links');
            });
            makeTableOfContentsScrollableIfNeeded();
            previousFocusElement.focus();
        });
    });
    document.querySelectorAll('.table-of-contents .see-less-button').forEach((seeLessButton) => {
        seeLessButton.addEventListener('click', () => {
            navLinkWrappers.forEach((navLinkWrapper) => {
                navLinkWrapper.classList.add('show-less-links');
                navLinkWrapper.classList.remove('show-more-links');
            });
            makeTableOfContentsScrollableIfNeeded();
            seeLessButton.parentElement.querySelector('.see-more-button').focus();
        });
    });
}
function setupAnchorScrollBehavior() {
    const navLinksItems = document.querySelectorAll(".nav-links a");

    navLinksItems.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();

            for (const link of navLinksItems) {
                link.classList.remove('active');
            }

            document.querySelectorAll('a[href="' + anchor.getAttribute('href') + '"]')
                .forEach((navItem) => navItem.classList.add('active'));
            const topOfElement = document.querySelector(anchor.getAttribute('href')).getBoundingClientRect().top + window.scrollY - 150;
            window.scroll({ top: topOfElement, behavior: 'smooth' });
        });
    });
}
let _IsScrolledIntoView = typeof isScrolledIntoView != 'undefined' ? isScrolledIntoView :
    function (element) {
        if (!element) {
            return false;
        }
        const boundingClientRectangle = element.getBoundingClientRect();
        const subnavMenu = document.querySelector('.subnav-menu');
        const offset = subnavMenu ? subnavMenu.clientHeight : 0;
        const isVisible = boundingClientRectangle.bottom - offset >= 0;
        return isVisible;
    };


function setupTableOfContentsJumpBehavior() {
    const contentSectionsWithToC = Array.from(document.querySelectorAll('.middle-rail-full-column'))
        .filter((contentSection) => contentSection.previousElementSibling !== null && contentSection.previousElementSibling.classList.contains('left-rail-full-column'));
    contentSectionsWithToC.forEach((column) => {
        window.addEventListener('scroll', () => {
            const currentContentSection = [].find.call(contentSectionsWithToC, (contentSection) => _IsScrolledIntoView(contentSection)) || contentSectionsWithToC[contentSectionsWithToC.length - 1];
            if (currentContentSection) {
                const toCElementForCurrentSection = currentContentSection.previousElementSibling.querySelector('.table-of-contents');
                if (toCElementForCurrentSection.style.display === 'none') toCElementForCurrentSection.style.display = '';
                contentSectionsWithToC.forEach((contentSection) => {
                    const toCElementForSection = contentSection.previousElementSibling.querySelector('.table-of-contents');
                    if (toCElementForSection === toCElementForCurrentSection || toCElementForSection.style.display === 'none') return;
                    toCElementForSection.style.display = 'none';
                });
            }
        });
    });
}
function conditionallyRenderSeeMoreLessButtons() {
    const links = document.querySelector('.nav-links'); 
    if (!links || links.childElementCount > 4) {
        return;
    }

    document.querySelectorAll('.table-of-contents .see-more-button, .table-of-contents .see-less-button').forEach((button) => button.style.display = 'none');
}
function maybeMoveInlineTableOfContentsUnderWistiaVideo() {
    if (document.querySelector('#video_script')) {
        return;
    }
    const wistiaVideoWrapper = document.querySelector('.middle-rail-full-column > .wistia_responsive_padding'); 
    const inlineTableOfContents = document.querySelector('.table-of-contents.toc-mobile');
    if (!wistiaVideoWrapper || !inlineTableOfContents) {
        return;
    }
    wistiaVideoWrapper.insertAdjacentElement('afterend', inlineTableOfContents.cloneNode(true));
    inlineTableOfContents.parentNode.removeChild(inlineTableOfContents);
}

function setupTableOfContents() {
    if (!document.querySelector('.table-of-contents') || document.querySelector('.table-of-contents.optTOC')) {
        return;
    }

    const nonEmptyHeadings = getArticleHeadings();
    if (!nonEmptyHeadings || nonEmptyHeadings.length < minimumNumberOfHeadings) {
        document.querySelectorAll('.table-of-contents').forEach((toc) => toc.style.display = 'none');
        return;
    }

    maybeMoveInlineTableOfContentsUnderWistiaVideo();
    addHeadingsToTableOfContents(nonEmptyHeadings);
    conditionallyRenderSeeMoreLessButtons();
    setupToggleClickHandlers();
    setupAnchorScrollBehavior();
    setupTableOfContentsJumpBehavior();
    setupTableOfContentsFocusBehavior();
    if (window.innerWidth >= 992) {
        const tableOfContents = document.querySelectorAll('.table-of-contents');
        const navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
        expandTableOfContents(navLinks, tableOfContents);
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 992) {
                expandTableOfContents(navLinks, tableOfContents);
            } else {
                collapseTableOfContents(navLinks, tableOfContents);
            }
        });
    }
}
var previousFocusElement = null;
window.addEventListener('DOMContentLoaded', (event) => {
    setupTableOfContents();
});

const setupFaqEventListeners = () => {
    const qaEntries = document.querySelectorAll('.xds-faq-question-btn');
    if (!qaEntries) {
        return;
    }

    qaEntries.forEach((qaEntry) => {
        const answerDiv = qaEntry.nextElementSibling;
        const focusableElements = answerDiv.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        focusableElements.forEach(el => {
            if (el.hasAttribute('tabindex')) {
                el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
            }
            el.setAttribute('tabindex', '-1');
        });
        
        qaEntry.addEventListener('click', () => {
            qaEntry.classList.toggle('active');
            const isHidden = answerDiv.getAttribute('aria-hidden') != 'true';
            answerDiv.setAttribute('aria-hidden', isHidden);
            const focusableElements = answerDiv.querySelectorAll('a, button, input, textarea, select, [data-original-tabindex]');
            focusableElements.forEach(el => {
                if (isHidden) {
                    el.setAttribute('tabindex', '-1');
                } else {
                    if (el.hasAttribute('data-original-tabindex')) {
                        el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
                    } else {
                        el.removeAttribute('tabindex');
                    }
                }
            });
        });
    });
};

window.addEventListener('DOMContentLoaded', setupFaqEventListeners);

function shouldHideArticleDate() {
    const excludedPaths = ['/howtohub/', '/lead/'];
    for (const excludedPath of excludedPaths) {
        if (window.location.pathname.includes(excludedPath)) {
            return false;
        }
    }
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    if (typeof localized_computed_date !== "undefined") {
        const last_modified_date = new Date(localized_computed_date);
        if (last_modified_date < oneYearAgo) {
            return true;
        }
    }
    return false;
}

function updateDateModifiedFieldInGooglePageScheme() {
    const scriptTag = document.getElementById("google-page-scheme");
    if (scriptTag) {
        const jsonLd = JSON.parse(scriptTag.textContent);
        jsonLd.dateModified = new Date(localized_computed_date).toISOString(); 
        scriptTag.textContent = JSON.stringify(jsonLd, null, 2);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    let localized_computed_date_changed = false;
    if (typeof localized_computed_date !== "undefined") {
        const radDateSelectors = [
            'x-indeed-hi-public[data-param="from_date"]',
            'x-indeed-adh[data-param="local_date_of_data"]'
        ];
        for (const radDateSelector of radDateSelectors) {
            for (const radDateTag of document.querySelectorAll(radDateSelector)) {
                const radDate = new Date(radDateTag.textContent);
                if (radDate instanceof Date && !isNaN(radDate) && new Date(localized_computed_date) < radDate) {
                    localized_computed_date = radDateTag.textContent;
                    localized_computed_date_changed = true;
                }
            }
        }
    }

    if (localized_computed_date_changed) {
        updateDateModifiedFieldInGooglePageScheme();
    }

    if (shouldHideArticleDate()) {
        const googlePageSchemeElement = document.querySelector("script[id='google-page-scheme']");
        if (googlePageSchemeElement) {
            googlePageSchemeElement.remove();
        }
    } else {
        const articleDateElementJs = document.querySelector(".xds-article-date.js");
        if (articleDateElementJs) {
            articleDateElementJs.style.display = 'block';
        }
    }
});
const i18nNumberFormat = (value, locale = 'en-US', style = 'decimal', decimalsPoints = 0, currency = undefined) => {
    let options;
    if (style === 'currency') {
        options = {
            style: style,
            currency: currency,
            maximumFractionDigits: decimalsPoints
        };
    } else {
        options = {
            style: style,
            maximumFractionDigits: decimalsPoints
        };
    }

    return new Intl.NumberFormat(locale, options).format(value);
};

const i18nDateFormat = (dateString, locale = 'en-US') => {
    const options = {
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
    };
    return new Date(dateString).toLocaleDateString(locale, options);
};
function replaceMonthPlaceholder(stringFromACF, formatedMonth) {
    return stringFromACF.replace('[month]', formatedMonth);
}

function getHIData(modalId, paramKey) {
    const tag = document.querySelector(
        `[data-param="${paramKey}"]${modalId ? `[data-modal-id="${modalId}"]` : ''}` 
    );
    if (!tag || !tag.textContent) {
        return '';
    }
    return tag.textContent;
}

function getHIDataIndex(
    modalId,
    paramKey,
    index
) {
    const tag = document.querySelector(
        `[data-param="${paramKey}"][data-modal-id="${modalId}"][data-index="${index}"]`
    );
    if (!tag || !tag.textContent) {
        return '';
    }
    return tag.textContent;
}
function replaceSalaryRangeValuesWithHI() {
    const fromDate = getHIData(null, 'from_date');
    const minSalary = getHIData(null, 'min_salary');
    const averageSalary = getHIData(null, 'average_salary');
    const maxSalary = getHIData(null, 'max_salary');
    const period = getHIData(null, 'pay_period');
    if (fromDate && minSalary && averageSalary && maxSalary && period && window.hiring_insight_localization) {
        const locale = window.hiring_insight_localization.locale;
        const salaryCurrency = window.hiring_insight_localization.currency;
        const periodLabel = window.hiring_insight_localization.period[period];

        if (window.hiring_insight_localization.display.numeric_salary) {
            document.querySelector(`.numeric-salary-information .average_salary_hi`).textContent = i18nNumberFormat(averageSalary, locale, 'currency', 0, salaryCurrency);
            document.querySelectorAll(`.numeric-salary-information .period_hi`).forEach(el => el.textContent = periodLabel);
            document.querySelector(`.numeric-salary-information .min_salary_hi`).textContent = i18nNumberFormat(minSalary, locale, 'currency', 0, salaryCurrency);
            document.querySelector(`.numeric-salary-information .max_salary_hi`).textContent = i18nNumberFormat(maxSalary, locale, 'currency', 0, salaryCurrency);
        }
        document.querySelector(`.from-date-salary-information .from_date_hi`).textContent = i18nDateFormat(fromDate);
    }
}

window.addEventListener('DOMContentLoaded', replaceSalaryRangeValuesWithHI, { once: true });

document.addEventListener("DOMContentLoaded", function () {
    function toggleMission(event) {
        const button = event.currentTarget;
        const missionText = button.closest('.mission-statement-container')?.querySelector('.mission-statement');
        const chevronIcon = button.querySelector('.mission-statement__chevron');

        if (!missionText) return;
       
        missionText.classList.toggle('mission-statement--expanded');

        if (chevronIcon) chevronIcon.classList.toggle('rotate');
    }
    document.querySelectorAll('.mission-statement__toggle-button').forEach(button => {
        button.addEventListener('click', toggleMission);
        button.addEventListener('touchstart', function (event) {
            event.preventDefault(); 
            toggleMission(event);
        });
    });
});

/*!
* tabbable 6.2.0
* @license MIT, https:
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.tabbable;
    var exports = global.tabbable = {};
    factory(exports);
    exports.noConflict = function () { global.tabbable = current; return exports; };
  })());
})(this, (function (exports) { 'use strict';
  var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
  var candidateSelector = candidateSelectors.join(',');
  var NoElement = typeof Element === 'undefined';
  var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
  } : function (element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
  };
  var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) {
      lookUp = true;
    }
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    var result = inert || lookUp && node && isInert(node.parentNode); 

    return result;
  };
  var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
  };
  var getCandidates = function getCandidates(el, includeContainer, filter) {
    if (isInert(el)) {
      return [];
    }
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();
      if (isInert(element, false)) {
        continue;
      }
      if (element.tagName === 'SLOT') {
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively(content, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: nestedCandidates
          });
        }
      } else {
        var validCandidate = matches.call(element, candidateSelector);
        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        }
        var shadowRoot = element.shadowRoot ||
        typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
        var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
        if (shadowRoot && validShadowRoot) {
          var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
          if (options.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scopeParent: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }
    return candidates;
  };
  var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
  };
  var getTabIndex = function getTabIndex(node) {
    if (!node) {
      throw new Error('No node provided');
    }
    if (node.tabIndex < 0) {
      if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
        return 0;
      }
    }
    return node.tabIndex;
  };
  var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
      return 0;
    }
    return tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
  };
  var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  };
  var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  };
  var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
      var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
      attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
      while (!attached && nodeRootHost) {
        var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
        nodeRoot = getRootNode(nodeRootHost);
        nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
        attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
      }
    }
    return attached;
  };
  var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
  };
  var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === 'hidden') {
      return true;
    }
    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
      return true;
    }
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
      if (typeof getShadowRoot === 'function') {
        var originalNode = node;
        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);
          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true 
          ) {
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            node = rootNode.host;
          } else {
            node = parentElement;
          }
        }
        node = originalNode;
      }

      if (isNodeAttached(node)) {
        return !node.getClientRects().length;
      }
      if (displayCheck !== 'legacy-full') {
        return true; 
      }
    } else if (displayCheck === 'non-zero-area') {
      return isZeroArea(node);
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === 'LEGEND') {
              return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled ||
    isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
      return false;
    }
    return true;
  };
  var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    }
    return false;
  };
  var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function (item, i) {
      var isScope = !!item.scopeParent;
      var element = isScope ? item.scopeParent : item;
      var candidateTabindex = getSortOrderTabIndex(element, isScope);
      var elements = isScope ? sortByOrder(item.candidates) : element;
      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item: item,
          isScope: isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };
  var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    }
    return sortByOrder(candidates);
  };
  var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    }
    return candidates;
  };
  var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) {
      throw new Error('No node provided');
    }
    if (matches.call(node, candidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorTabbable(options, node);
  };
  var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
  var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) {
      throw new Error('No node provided');
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options, node);
  };

  exports.focusable = focusable;
  exports.getTabIndex = getTabIndex;
  exports.isFocusable = isFocusable;
  exports.isTabbable = isTabbable;
  exports.tabbable = tabbable;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/*!
* focus-trap 7.6.4
* @license MIT, https:
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('tabbable')) :
  typeof define === 'function' && define.amd ? define(['exports', 'tabbable'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.focusTrap;
    var exports = global.focusTrap = {};
    factory(exports, global.tabbable);
    exports.noConflict = function () { global.focusTrap = current; return exports; };
  })());
})(this, (function (exports, tabbable) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }
  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined;
    }
  }

  var activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
      if (trapStack.length > 0) {
        var activeTrap = trapStack[trapStack.length - 1];
        if (activeTrap !== trap) {
          activeTrap._setPausedState(true);
        }
      }
      var trapIndex = trapStack.indexOf(trap);
      if (trapIndex === -1) {
        trapStack.push(trap);
      } else {
        trapStack.splice(trapIndex, 1);
        trapStack.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
      var trapIndex = trapStack.indexOf(trap);
      if (trapIndex !== -1) {
        trapStack.splice(trapIndex, 1);
      }
      if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) {
        trapStack[trapStack.length - 1]._setPausedState(false);
      }
    }
  };
  var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  };
  var isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Escape' || (e === null || e === undefined ? undefined : e.key) === 'Esc' || (e === null || e === undefined ? undefined : e.keyCode) === 27;
  };
  var isTabEvent = function isTabEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Tab' || (e === null || e === undefined ? undefined : e.keyCode) === 9;
  };
  var isKeyForward = function isKeyForward(e) {
    return isTabEvent(e) && !e.shiftKey;
  };
  var isKeyBackward = function isKeyBackward(e) {
    return isTabEvent(e) && e.shiftKey;
  };
  var delay = function delay(fn) {
    return setTimeout(fn, 0);
  };
  var valueOrHandler = function valueOrHandler(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === 'function' ? value.apply(undefined, params) : value;
  };
  var getActualTarget = function getActualTarget(event) {
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
  };
  var internalTrapStack = [];
  var createFocusTrap = function createFocusTrap(elements, userOptions) {
    var doc = (userOptions === null || userOptions === undefined ? undefined : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === undefined ? undefined : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true,
      isKeyForward: isKeyForward,
      isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
      containers: [],
      containerGroups: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      manuallyPaused: false,
      delayInitialFocusTimer: undefined,
      recentNavEvent: undefined
    };
    var trap; 
    var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex(element, event) {
      var composedPath = typeof (event === null || event === undefined ? undefined : event.composedPath) === 'function' ? event.composedPath() : undefined;
      return state.containerGroups.findIndex(function (_ref) {
        var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || (
        composedPath === null || composedPath === undefined ? undefined : composedPath.includes(container)) || tabbableNodes.find(function (node) {
          return node === element;
        });
      });
    };
    var getNodeForOption = function getNodeForOption(optionName) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$hasFallback = _ref2.hasFallback,
        hasFallback = _ref2$hasFallback === undefined ? false : _ref2$hasFallback,
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? [] : _ref2$params;
      var optionValue = config[optionName];
      if (typeof optionValue === 'function') {
        optionValue = optionValue.apply(undefined, _toConsumableArray(params));
      }
      if (optionValue === true) {
        optionValue = undefined; 
      }
      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        }

        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue; 

      if (typeof optionValue === 'string') {
        try {
          node = doc.querySelector(optionValue); 
        } catch (err) {
          throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
        }
        if (!node) {
          if (!hasFallback) {
            throw new Error("`".concat(optionName, "` as selector refers to no known node"));
          }
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
      var node = getNodeForOption('initialFocus', {
        hasFallback: true
      });
      if (node === false) {
        return false;
      }
      if (node === undefined || node && !tabbable.isFocusable(node, config.tabbableOptions)) {
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption('fallbackFocus');
        }
      } else if (node === null) {
        node = getNodeForOption('fallbackFocus');
      }
      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
      state.containerGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable.tabbable(container, config.tabbableOptions);
        var focusableNodes = tabbable.focusable(container, config.tabbableOptions);
        var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
        var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
        var firstDomTabbableNode = focusableNodes.find(function (node) {
          return tabbable.isTabbable(node);
        });
        var lastDomTabbableNode = focusableNodes.slice().reverse().find(function (node) {
          return tabbable.isTabbable(node);
        });
        var posTabIndexesFound = !!tabbableNodes.find(function (node) {
          return tabbable.getTabIndex(node) > 0;
        });
        return {
          container: container,
          tabbableNodes: tabbableNodes,
          focusableNodes: focusableNodes,
          posTabIndexesFound: posTabIndexesFound,
          firstTabbableNode: firstTabbableNode,
          lastTabbableNode: lastTabbableNode,
          firstDomTabbableNode: firstDomTabbableNode,
          lastDomTabbableNode: lastDomTabbableNode,
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var nodeIdx = tabbableNodes.indexOf(node);
            if (nodeIdx < 0) {
              if (forward) {
                return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function (el) {
                  return tabbable.isTabbable(el);
                });
              }
              return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function (el) {
                return tabbable.isTabbable(el);
              });
            }
            return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function (group) {
        return group.tabbableNodes.length > 0;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') 
      ) {
        throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
      }
      if (state.containerGroups.find(function (g) {
        return g.posTabIndexesFound;
      }) && state.containerGroups.length > 1) {
        throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
      }
    };
    var _getActiveElement = function getActiveElement(el) {
      var activeElement = el.activeElement;
      if (!activeElement) {
        return;
      }
      if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
        return _getActiveElement(activeElement.shadowRoot);
      }
      return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
      if (node === false) {
        return;
      }
      if (node === _getActiveElement(document)) {
        return;
      }
      if (!node || !node.focus) {
        _tryFocus(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus', {
        params: [previousActiveElement]
      });
      return node ? node : node === false ? false : previousActiveElement;
    };
    var findNextNavNode = function findNextNavNode(_ref3) {
      var target = _ref3.target,
        event = _ref3.event,
        _ref3$isBackward = _ref3.isBackward,
        isBackward = _ref3$isBackward === undefined ? false : _ref3$isBackward;
      target = target || getActualTarget(event);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findContainerIndex(target, event);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
        if (containerIndex < 0) {
          if (isBackward) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (isBackward) {
          var startOfGroupIndex = state.tabbableGroups.findIndex(function (_ref4) {
            var firstTabbableNode = _ref4.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target, false);
          }
        } else {
          var lastOfGroupIndex = state.tabbableGroups.findIndex(function (_ref5) {
            var lastTabbableNode = _ref5.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target);
          }
        }
      } else {
        destinationNode = getNodeForOption('fallbackFocus');
      }
      return destinationNode;
    };
    var checkPointerDown = function checkPointerDown(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target, e) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn(event) {
      var target = getActualTarget(event);
      var targetContained = findContainerIndex(target, event) >= 0;
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        event.stopImmediatePropagation();
        var nextNode; 
        var navAcrossContainers = true;
        if (state.mostRecentlyFocusedNode) {
          if (tabbable.getTabIndex(state.mostRecentlyFocusedNode) > 0) {
            var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
            var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
            if (tabbableNodes.length > 0) {
              var mruTabIdx = tabbableNodes.findIndex(function (node) {
                return node === state.mostRecentlyFocusedNode;
              });
              if (mruTabIdx >= 0) {
                if (config.isKeyForward(state.recentNavEvent)) {
                  if (mruTabIdx + 1 < tabbableNodes.length) {
                    nextNode = tabbableNodes[mruTabIdx + 1];
                    navAcrossContainers = false;
                  }
                } else {
                  if (mruTabIdx - 1 >= 0) {
                    nextNode = tabbableNodes[mruTabIdx - 1];
                    navAcrossContainers = false;
                  }
                }
              }
            }
          } else {
            if (!state.containerGroups.some(function (g) {
              return g.tabbableNodes.some(function (n) {
                return tabbable.getTabIndex(n) > 0;
              });
            })) {
              navAcrossContainers = false;
            }
          }
        } else {
          navAcrossContainers = false;
        }
        if (navAcrossContainers) {
          nextNode = findNextNavNode({
            target: state.mostRecentlyFocusedNode,
            isBackward: config.isKeyBackward(state.recentNavEvent)
          });
        }
        if (nextNode) {
          _tryFocus(nextNode);
        } else {
          _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
      }
      state.recentNavEvent = undefined; 
    };
    var checkKeyNav = function checkKeyNav(event) {
      var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      state.recentNavEvent = event;
      var destinationNode = findNextNavNode({
        event: event,
        isBackward: isBackward
      });
      if (destinationNode) {
        if (isTabEvent(event)) {
          event.preventDefault();
        }
        _tryFocus(destinationNode);
      }
    };
    var checkTabKey = function checkTabKey(event) {
      if (config.isKeyForward(event) || config.isKeyBackward(event)) {
        checkKeyNav(event, config.isKeyBackward(event));
      }
    };
    var checkEscapeKey = function checkEscapeKey(event) {
      if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
        event.preventDefault();
        trap.deactivate();
      }
    };
    var checkClick = function checkClick(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target, e) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };

    var addListeners = function addListeners() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trapStack, trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        _tryFocus(getInitialFocusNode());
      }) : _tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkTabKey, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkEscapeKey);
      return trap;
    };
    var removeListeners = function removeListeners() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkTabKey, true);
      doc.removeEventListener('keydown', checkEscapeKey);
      return trap;
    };

    var checkDomRemoval = function checkDomRemoval(mutations) {
      var isFocusedNodeRemoved = mutations.some(function (mutation) {
        var removedNodes = Array.from(mutation.removedNodes);
        return removedNodes.some(function (node) {
          return node === state.mostRecentlyFocusedNode;
        });
      });
      if (isFocusedNodeRemoved) {
        _tryFocus(getInitialFocusNode());
      }
    };
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
      if (!mutationObserver) {
        return;
      }
      mutationObserver.disconnect();
      if (state.active && !state.paused) {
        state.containers.map(function (container) {
          mutationObserver.observe(container, {
            subtree: true,
            childList: true
          });
        });
      }
    };

    trap = {
      get active() {
        return state.active;
      },
      get paused() {
        return state.paused;
      },
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, 'onActivate');
        var onPostActivate = getOption(activateOptions, 'onPostActivate');
        var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        onActivate === null || onActivate === undefined || onActivate();
        var finishActivation = function finishActivation() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          updateObservedNodes();
          onPostActivate === null || onPostActivate === undefined || onPostActivate();
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        var options = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);
        clearTimeout(state.delayInitialFocusTimer); 
        state.delayInitialFocusTimer = undefined;
        removeListeners();
        state.active = false;
        state.paused = false;
        updateObservedNodes();
        activeFocusTraps.deactivateTrap(trapStack, trap);
        var onDeactivate = getOption(options, 'onDeactivate');
        var onPostDeactivate = getOption(options, 'onPostDeactivate');
        var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
        var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
        onDeactivate === null || onDeactivate === undefined || onDeactivate();
        var finishDeactivation = function finishDeactivation() {
          delay(function () {
            if (returnFocus) {
              _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            onPostDeactivate === null || onPostDeactivate === undefined || onPostDeactivate();
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause(pauseOptions) {
        if (!state.active) {
          return this;
        }
        state.manuallyPaused = true;
        return this._setPausedState(true, pauseOptions);
      },
      unpause: function unpause(unpauseOptions) {
        if (!state.active) {
          return this;
        }
        state.manuallyPaused = false;
        if (trapStack[trapStack.length - 1] !== this) {
          return this;
        }
        return this._setPausedState(false, unpauseOptions);
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === 'string' ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        updateObservedNodes();
        return this;
      }
    };
    Object.defineProperties(trap, {
      _isManuallyPaused: {
        value: function value() {
          return state.manuallyPaused;
        }
      },
      _setPausedState: {
        value: function value(paused, options) {
          if (state.paused === paused) {
            return this;
          }
          state.paused = paused;
          if (paused) {
            var onPause = getOption(options, 'onPause');
            var onPostPause = getOption(options, 'onPostPause');
            onPause === null || onPause === undefined || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === undefined || onPostPause();
          } else {
            var onUnpause = getOption(options, 'onUnpause');
            var onPostUnpause = getOption(options, 'onPostUnpause');
            onUnpause === null || onUnpause === undefined || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === undefined || onPostUnpause();
          }
          return this;
        }
      }
    });
    trap.updateContainerElements(elements);
    return trap;
  };

  exports.createFocusTrap = createFocusTrap;

}));

document.addEventListener('DOMContentLoaded', function () {
    let lastFocusedElement = null;
    let focusTrapInstance = null;

    function showModal(editorsNoteLabel, termTitle, definition, links, linksLabel) {
        const modal = document.getElementById('editors-note-modal');
        const titleEl = document.getElementById('editors-note-modal-title');
        const contentEl = document.getElementById('editors-note-modal-content');

        if (!modal || !titleEl || !contentEl) {
            console.warn('Editor’s Note modal elements not found.');
            return;
        }
        if (!modal.hasAttribute('hidden')) {
            return;
        }

        lastFocusedElement = document.activeElement;

        titleEl.textContent = editorsNoteLabel;

        let contentHTML = `
            <div class="editors-note-modal__wrapper">
                <span class="editors-note-modal-term-title"><strong>${termTitle}</strong></span>
                <p class="editors-note-modal-paragraph">${definition}</p>
            </div>
        `;

        if (Array.isArray(links) && links.length > 0) {
            contentHTML += `<span class="editors-note-modal-links-label"><strong>${linksLabel}</strong></span><ul>`;
            links.forEach(linkObj => {
                if (typeof linkObj === 'object' && linkObj.url && linkObj.title) {
                    const url = String(linkObj.url).trim();
                    const linkTitle = String(linkObj.title).trim();
                    contentHTML += `
                        <li class="editors-note-modal-link">
                            <a href="${url}" target="_blank" rel="noopener noreferrer">${linkTitle}</a>
                        </li>`;
                } else {
                    console.error("Invalid link object:", linkObj);
                }
            });
            contentHTML += '</ul>';
        }

        contentEl.innerHTML = contentHTML;
        modal.removeAttribute('hidden');
        modal.style.display = 'flex';
        modal.setAttribute('aria-hidden', 'false');

        if (window.focusTrap) {
            focusTrapInstance = window.focusTrap.createFocusTrap(modal, {
                escapeDeactivates: true,
                clickOutsideDeactivates: true,
                fallbackFocus: modal,
                initialFocus: modal,
            });
            focusTrapInstance.activate();
        }
    }

    function hideModal() {
        const modal = document.getElementById('editors-note-modal');
        const contentEl = document.getElementById('editors-note-modal-content');

        if (!modal || modal.hasAttribute('hidden')) {
            return;
        }

        modal.setAttribute('hidden', true);
        modal.setAttribute('aria-hidden', 'true');
        modal.style.display = 'none';

        if (contentEl) {
            contentEl.innerHTML = ''; 
        }

        if (focusTrapInstance) {
            focusTrapInstance.deactivate();
            focusTrapInstance = null;
        }

        if (lastFocusedElement) {
            lastFocusedElement.focus();
        }
    }

    document.body.addEventListener('click', function (e) {
        const editorsNote = e.target.closest('.editors-note');
        if (editorsNote) {
            e.preventDefault();

            const definition = editorsNote.getAttribute('data-definition');
            const termTitle = editorsNote.textContent.trim();
            const editorsNoteLabel = editorsNote.getAttribute('data-editors-note') || "Editor's Note";
            const linksLabel = editorsNote.getAttribute('data-links-label') || "Related resources";
            const links = JSON.parse(editorsNote.getAttribute('data-links'));

            showModal(editorsNoteLabel, termTitle, definition, links, linksLabel);
        }

        if (e.target.matches('.editors-note-icon')) {
            e.preventDefault();
            const editorsNote = e.target.previousElementSibling;
            if (editorsNote && editorsNote.classList.contains('editors-note')) {
                editorsNote.click();
            }
        }
    });

    const closeBtn = document.getElementById('editors-note-close-modal');
    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            hideModal();
        });
    }

    window.addEventListener('click', function (e) {
        const modal = document.getElementById('editors-note-modal');
        if (!modal) return;

        const modalContent = modal.querySelector('.modal-content');
        if (e.target === modal && (!modalContent || !modalContent.contains(e.target))) {
            hideModal();
        }
    });

    window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            hideModal();
        } else if(e.key === "Enter") {
            const editorsNote = e.target.closest('.editors-note');
            if (editorsNote) {
                e.preventDefault();
                editorsNote.click();
            }
        }
    });
});

function articleRecommendationCarousel() {
    const exampleBar = document.querySelector('#articleRecommendation');
    if (exampleBar == null) {
        return;
    }
    const itemList = exampleBar.querySelectorAll('.article-recommendation__carousel-slide');
    const numItems = itemList.length;
    const numCardsPerViewOnDesktop = Math.min(3, numItems);
    const numCardsPerViewOnTablet = Math.min(2, numItems);
    const numCardsPerViewOnMobile = Math.min(2, numItems);
    const swiperOptions = {
        init: false,
        slidesPerView: numCardsPerViewOnMobile,
        slidesPerGroup: numCardsPerViewOnMobile,
        spaceBetween: 48,
        observer: true,
        observeParents: true,
        slideToClickedSlide: true,
        simulateTouch: false,
        direction: 'horizontal',
        breakpoints: {
            992: {
                slidesPerView: numCardsPerViewOnDesktop,
                slidesPerGroup: numCardsPerViewOnDesktop,
            },
            768: {
                slidesPerView: numCardsPerViewOnTablet,
                slidesPerGroup: numCardsPerViewOnTablet,
            }
        },
        navigation: {
            nextEl: '.article-recommendation__carousel-change-page-right-btn',
            prevEl: '.article-recommendation__carousel-change-page-left-btn'
        }
    };

    const swiper = new Swiper('.swiper', swiperOptions);
    swiper.init();
}

function toggleDropdown(event) {
    const button = event.currentTarget;
    const recommendationList = button.closest('.article-recommendation-wrap').querySelector('.article-recommendation__list');
    const chevronIcon = button.querySelector('.article-recommendation__chevron');

    if (!recommendationList) return;

    recommendationList.classList.toggle('article-recommendation--expanded');
    recommendationList.classList.toggle('hide');

    if (chevronIcon) chevronIcon.classList.toggle('rotate');
}

function initalizeArticleRecommendationCarouselOnLoad() {
    articleRecommendationCarousel();
    document.querySelectorAll('.article-recommendation__toggle-button').forEach(button => {
        button.addEventListener('click', toggleDropdown);
        button.addEventListener('touchstart', function (event) {
            event.preventDefault(); 
            toggleDropdown(event);
        });
    });
}
window.addEventListener('DOMContentLoaded', initalizeArticleRecommendationCarouselOnLoad, { once: true });
class ProgressBar {
  constructor() {
    this.subcategoryMenu = document.getElementById("internal-component-smb-subcategory-menu");
    this.progressBarContainer = document.querySelector('.scroll-progress-container');
    this.progressBar = this.progressBarContainer?.querySelector(".scroll-progress-bar");

    if (!this.progressBar) {
      return;
    }
    this.updateProgress = this.updateProgress.bind(this);
    this.debouncedUpdateProgress = this.debounce(this.updateProgress, 10);
    this.handleResize = this.handleResize.bind(this);
    this.debouncedSetPosition = this.debounce(this.updatePosition.bind(this), 100);

    this.init();
  }
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  init() {
    requestAnimationFrame(() => {
      this.updatePosition();
      this.setupEventListeners();
      this.updateProgress();
    });
  }
  updatePosition() {
    if (this.subcategoryMenu && this.progressBarContainer) {
      const currentHeight = this.subcategoryMenu.offsetHeight;
      const newTopValue = currentHeight + 'px';
      const currentTopValue = this.progressBarContainer.style.getPropertyValue('--subcategory-menu-height');

      if (newTopValue !== currentTopValue) {
        this.progressBarContainer.style.setProperty('--subcategory-menu-height', newTopValue);
      }
    }
  }
  handleResize() {
    this.debouncedSetPosition();
    this.debouncedUpdateProgress();
  }
  setupEventListeners() {
    window.addEventListener('scroll', this.debouncedUpdateProgress, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
  }
  updateProgress() {
    if (!this.progressBar) return;

    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    if (height <= 0) {
      this.progressBar.style.width = "100%";
      return;
    }

    let scrolled = (winScroll / height) * 100;
    scrolled = Math.max(0, Math.min(100, scrolled));
    this.progressBar.style.width = scrolled + "%";
  }
}
function initializeProgressBar() {
  new ProgressBar();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProgressBar);
} else {
  initializeProgressBar();
}
function initAuthorBylineComponents() {
  const hideTooltip = (tooltipEl) => {
    if (!tooltipEl) return;
    tooltipEl.classList.remove('is-visible');
    tooltipEl.setAttribute('hidden', 'true');
    const selector = `.author-profile-trigger[aria-controls="${tooltipEl.id}"], .author-profile-trigger[data-tooltip-id="${tooltipEl.id}"]`;
    const trigger = document.querySelector(selector);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  };

  const hideAllTooltips = () => {
    document.querySelectorAll('.author-tooltip.is-visible').forEach(hideTooltip);
  };
  document
    .querySelectorAll('.author-byline-group')
    .forEach((containerRoot) => {
      const toggleBtn = containerRoot.querySelector('.toggle-additional-contributors');
      if (toggleBtn) {
        const targetId = toggleBtn.getAttribute('aria-controls');
        const contributorsContainer = targetId ? containerRoot.querySelector(`#${targetId}`) : null;

        if (contributorsContainer) {
          const isInitiallyOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
          contributorsContainer.style.display = isInitiallyOpen ? 'block' : 'none';
          contributorsContainer.toggleAttribute('hidden', !isInitiallyOpen);

          toggleBtn.addEventListener('click', () => {
            const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
            const show = !isOpen;
            toggleBtn.setAttribute('aria-expanded', String(show));
            contributorsContainer.style.display = show ? 'block' : 'none';
            contributorsContainer.toggleAttribute('hidden', !show);
          });
        }
      }
      containerRoot.querySelectorAll('.author-profile-trigger').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const tooltipId =
            trigger.getAttribute('aria-controls') || trigger.getAttribute('data-tooltip-id');
          if (!tooltipId) return;

          const tooltip = document.getElementById(tooltipId);
          if (!tooltip) return;
          if (tooltip.parentElement !== document.body) {
            document.body.appendChild(tooltip);
          }
          hideAllTooltips();

          tooltip.removeAttribute('hidden');
          tooltip.classList.add('is-visible');
          trigger.setAttribute('aria-expanded', 'true');
        });
      });
    });
  document.body.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.author-tooltip__close');
    if (closeBtn) {
      const tooltipEl = closeBtn.closest('.author-tooltip');
      hideTooltip(tooltipEl);
      return;
    }

    const inTooltip = e.target.closest('.author-tooltip');
    const inTrigger = e.target.closest('.author-profile-trigger');
    if (!inTooltip && !inTrigger) {
      hideAllTooltips();
    }
  });

  document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hideAllTooltips();
  });
}
document.addEventListener('DOMContentLoaded', initAuthorBylineComponents);

